export const VERSION_DATA_EXPIRATION_TIME = 30 * 60 * 1000;
export const CHARACTERS_PER_PAGE = 20;

export const UNIT_GROUPS = [
    "Human",
    "Elf",
    "Therianthrope",
    "Vampire",
    "Shadow Garden",
    "Midgar",
    "Oriana",
    "Velgalta",
    "Seven Shadows",
    "Slime Suit",
    "Uniform",
    "Demon",
    "Apocrypha",
    "Tag",
    "Others"
]

export const ID_GROUPS = {
    "1001": "Cid/Shadow",
    "1002": "Alpha",
    "1003": "Beta",
    "1004": "Gamma",
    "1005": "Delta",
    "1006": "Epsilon",
    "1007": "Zeta",
    "1008": "Eta",
    "1009": "Nu",
    "1012": "Claire",
    "1013": "Alexia",
    "1014": "Iris",
    "1015": "Rose",
    "1016": "Sherry",
    "1017": "Aurora",
    "1020": "Beatrix",
    "1021": "Annerose",
    "1022": "Lambda",
    "1023": "Victoria",
    "1024": "Elisabeth",
    "1025": "Yukime",
    "1801": "Tag",
    "1802": "Tag",
}

export const BUFF_MAP = {
    "1": "ATK",
    "2": "DEF",
    "3": "CRIT Rate",
    "4": "CRIT ATK",
    "5": "CRIT DEF",
    "9": "Healing Boost",
    "10": "SP Boost Rate",
    "11": "SP Discount",
    "12": "EVA",
    "13": "ACC",
    "14": "Ongoing HP Recovery",
    "15": "DMG Inflicted",
    "16": "DMG Received",
    "17": "Speed",
    "18": "Poison",
    "19": "Bleed",
    "20": "Stun",
    "21": "Paralysis",
    "22": "Sleep",
    "23": "Seal",
    "24": "Dark",
    "25": "Slow",
    "26": "Provoke",
    "27": "Hidden Technique DMG",
    "28": "Lucky Lecher Lure",
    "30": "Shield",
    "31": "Rest",
    "32": "Knockback",
    "33": "Steel Threads",
    "34": "Demon Power",
    "36": "Parry",
    "37": "Overheal",
    "39": "Charge",
    "40": "DMG Limit",
    "41": "Blood Heal",
    "42": "Strongest Sword",
    "301": "Invincibility",
    "312": "Magic Blockage",
    "317": "Weakness",
    "318": "Nullify Bleed Removal",
    "319": "Freeze",
    "401": "Mystic Power",
    "402": "Nekko",
    "403": "Unleashed",
    "404": "Sound Seal",
    "405": "Word Seal",
    "406": "Add Group",
    "407": "Shackles"
}

export const BUFF_GROUPS = {
    "1": {
        "type": "b",
        "buffs": ["1", "2", "3", "4", "5", "9", "10", "11", "12", "13", "14", "15", "16", "17", "27", "30", "31", "33", "34", "36", "37", "39", "40", "41", "42", "301"]
    },
    "2": {
        "type": "b",
        "buffs": ["18", "19", "20", "21", "22", "23", "24", "25", "26", "32", "318"]
    },
    "3": {
        "type": "d",
        "buffs": ["1", "2", "3", "4", "5", "9", "10", "12", "13", "15", "16", "17", "28"]
    },
    "4": {
        "type": "d",
        "buffs": ["18", "19", "20", "21", "22", "23", "24", "25", "26", "312", "317", "319"]
    },
    "5": {
        "type": "b",
        "buffs": ["401", "402", "403", "404", "405", "406", "407"]
    }
}

export const ROLE_MAP = {
    t: 'tank',
    a: 'dps',
    h: 'heal',
};

export const GROUPS_MAP = {
    'Race': ['Human', 'Therianthrope', 'Elf', 'Vampire'],
    'Affiliation': ['Seven Shadows', 'Midgar', 'Oriana', 'Velgalta'],
    'Clothes': ['Slime Suit', 'Uniform', 'Apocrypha', 'Demon'],
    'Shadow Garden': ['Shadow Garden'],
    'Idol': ['Idol'],
    'Tag': ['Tag'],
    'Others': ['Other'],
    'Rui': ['Female Executive Officer'],
    'La+': ['Founder']
}

export const LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'fr-FR', label: 'Français' },
];

const roleContext = require.context('./assets/images/roles', false, /\.webp$/);

export const ROLES = roleContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = roleContext(key);
    return acc;
}, {});

const rarityContext = require.context('./assets/images/rarity', false, /\.webp$/);

export const RARITY = rarityContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = rarityContext(key);
    return acc;
}, {});

const skillsContext = require.context('./assets/images/skills', false, /\.webp$/);

export const SKILLS = skillsContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = skillsContext(key);
    return acc;
}, {});

const awakeningContext = require.context('./assets/images/awakening', false, /\.webp$/);

export const AWAKENING = awakeningContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = awakeningContext(key);
    return acc;
}, {});

const groupsContext = require.context('./assets/images/groups', false, /\.png$/);

export const GROUPS = groupsContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.png', '');
    acc[name] = groupsContext(key);
    return acc;
}, {});

const tagContext = require.context('./assets/images/tag', false, /\.webp$/);

export const TAG = tagContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = tagContext(key);
    return acc;
}, {});

const menuContext = require.context('./assets/images/menu', false, /\.webp$/);

export const MENU = menuContext.keys().reduce((acc, key) => {
    const name = key.replace('./', '').replace('.webp', '');
    acc[name] = menuContext(key);
    return acc;
}, {});